import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid, { HubCardItem } from '../../components/PanelHubGrid';

const ALL_CARDS: (HubCardItem & { referentFunction?: string })[] = [
  { to: '/panel/joueurs', title: 'Joueurs', description: 'Liste, fiches et statut premium.', accent: 'sky' },
  { to: '/panel/moderation', title: 'Moderation avancee', description: 'Deblocages au-dessus du niveau modo.', accent: 'amber' },
  { to: '/panel/scenarios', title: 'Scenarios & CTA', description: 'CTA en cours, scenarios et creation.', accent: 'cyan' },
  { to: '/panel/logs', title: 'Logs & securite', description: 'Tracabilite complete.', accent: 'emerald' },
  { to: '/panel/users/roles', title: 'Roles & acces', description: 'Referent Admin : permissions utilisateurs.', accent: 'violet', referentFunction: 'Referent Admin' },
  { to: '/panel/roles/default-access', title: 'Acces panel (roles)', description: 'Defauts des sections par role.', accent: 'violet' },
];

const PanelAdminHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection, hasReferentFunction } = usePanelAccess();
  const roleId = currentUser?.roles_id ?? 0;
  const canEnterHub = hasAccessToSection('salon_admin');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  const cards = useMemo(() => {
    return ALL_CARDS.filter((c) => {
      if (c.referentFunction) {
        if (roleId === 1) return true;
        return hasReferentFunction(c.referentFunction);
      }
      return true;
    });
  }, [hasReferentFunction, roleId]);

  if (!currentUser || loading || !canEnterHub) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Administration : joueurs, moderation, scenarios et deblocages. Pas d'acces maintenance / config CM."
      cards={cards}
    />
  );
};

export default PanelAdminHubV1;
